import React, { useState, useEffect } from "react";
import calendarIcon from "../../../../../../Assets/images/calender.svg";
import apiClient from "../../../../../../Config/apiClient";
import { showErrorToast } from "../../../../../../Context/Toaster/Toaster";
import "../error.scss"
import Loader from "../../../../../../Context/Loader/Loader";
import { saveAs } from "file-saver";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DATE_MONTH_FORMAT } from "../../../Utils/Constants";

const summaryPath = process.env.REACT_APP_HS_SUMMARY_BASE_PATH;
const constructionCompanyPath = process.env.REACT_APP_HS_CONSTRUCTION_COMPANY_BASE_PATH;
const truckCompanyPath = process.env.REACT_APP_HS_TRUCK_COMPANY_BASE_PATH;

const JobSummaryTab = () => {
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [jobStatus, setJobStatus] = useState("Any");
    const [jobType, setJobType] = useState("Any");
    const [postedBy, setPostedBy] = useState("Any");
    const [doneBy, setDoneBy] = useState("Any");
    const [loading, setLoading] = useState(false);

    const [constructionCompanies, setConstructionCompanies] = useState([]);
    const [truckCompanies, setTruckCompanies] = useState([]);

    const [errors, setErrors] = useState({
        start: "",
        end: "",
        range: "",
    });

    const filenameFromDisposition = (cd) => {
        if (!cd) return null;
        const match = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        return match ? match[1].replace(/['"]/g, "") : null;
    };

    const fetchConstructionCompanies = async () => {
        try {
            const response = await apiClient.get(`${constructionCompanyPath}/`);
            if (response.data && response.data.data) {
                setConstructionCompanies(response.data.data);
            }
        } catch (error) {
            showErrorToast("Error fetching construction companies", error);
        }
    };

    const fetchTruckCompanies = async () => {
        try {
            const response = await apiClient.get(`${truckCompanyPath}/`);
            if (response.data && response.data.data) {
                setTruckCompanies(response.data.data);
            }
        } catch (error) {
            showErrorToast("Error fetching truck companies", error);
        }
    };

    useEffect(() => {
        fetchConstructionCompanies();
        fetchTruckCompanies();
    }, []);

    const validateDates = () => {
        let valid = true;
        let newErrors = { start: "", end: "", range: "" };

        if (!startTime) {
            newErrors.start = "Start date is required";
            valid = false;
        }
        if (!endTime) {
            newErrors.end = "End date is required";
            valid = false;
        }

        if (startTime && endTime) {
            const start = new Date(startTime);
            const end = new Date(endTime);

            if (start > end) {
                newErrors.start = "Start date cannot be after End date";
                valid = false;
            } else {
                const startMonth = start.getMonth();
                const startYear = start.getFullYear();
                const endMonth = end.getMonth();
                const endYear = end.getFullYear();

                const monthDiff =
                    (endYear - startYear) * 12 + (endMonth - startMonth) + 1;

                if (monthDiff > 3) {
                    newErrors.range = "Report can only be generated for a maximum of 3 months";
                    valid = false;
                }
            }
        }

        setErrors(newErrors);
        return valid;
    };

    const handleGenerate = async () => {
        if (!validateDates()) {
            return;
        }

        try {
            setLoading(true);
            const payload = {
                startDate: startTime || null,
                endDate: endTime || null,
                jobStatus,
                jobType,
                constructionCompany: postedBy,
                truckCompany: doneBy,
            };

            const response = await apiClient.post(`${summaryPath}/job-summary`, payload,
                { responseType: "blob" }
            );

            const cd = response.headers?.["content-disposition"] || response.headers?.get?.("content-disposition");
            const filename = filenameFromDisposition(cd) || "job_summary.xlsx";
            saveAs(response.data, filename);
        } catch (error) {
            showErrorToast("No job summary found for the selected options", error);
        }
        finally {
            setLoading(false);
        }

    };

    return (
        <div className="tab-pane fade show active" id="start" role="tabpanel" aria-labelledby="start-tab">
            <div className="report-tabinner">
                <div className="reportform-cover new-height mt-0">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="cp-split">
                                <label className="fi-label">Start date <span style={{ color: "red" }}>*</span></label>
                                <div className="datepicker-wrapper">
                                    <DatePicker
                                        selected={startTime ? new Date(startTime) : null}
                                        onChange={(date) => { 
                                            setStartTime(date ? date.toLocaleDateString("en-CA") : ""); 
                                            setErrors({ ...errors, start: "", range: "" }); 
                                        }}
                                        placeholderText="Select start date"
                                        className={`custom-datetime-input common-input ${errors.start ? "error" : ""}`}
                                        dateFormat={DATE_MONTH_FORMAT}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        popperProps={{ strategy: 'fixed' }}
                                        autoComplete="off"
                                        portalId="root"
                                    />
                                    <img alt="Calendar" className="rpt-calendar-icon" src={calendarIcon} />
                                </div>
                                {errors.start && <div className="error-text active">{errors.start}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="cp-split">
                                <label className="fi-label">End date <span style={{ color: "red" }}>*</span></label>
                                <div className="datepicker-wrapper">
                                    <DatePicker
                                        selected={endTime ? new Date(endTime) : null}
                                        onChange={(date) => { 
                                            setEndTime(date ? date.toLocaleDateString("en-CA") : ""); 
                                            setErrors({ ...errors, end: "", range: "" }); 
                                        }}
                                        placeholderText="Select end date"
                                        className={`custom-datetime-input common-input ${errors.end || errors.range ? "error" : ""}`}
                                        dateFormat={DATE_MONTH_FORMAT}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        popperProps={{ strategy: 'fixed' }}
                                        autoComplete="off"
                                        portalId="root"
                                    />
                                    <img alt="Calendar" className="rpt-calendar-icon" src={calendarIcon} />
                                </div>
                                {errors.end && <div className="error-text active">{errors.end}</div>}
                                {errors.range && <div className="error-text active">{errors.range}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="cp-split">
                                <label className="fi-label">Job Status</label>
                                <select className="common-select" value={jobStatus} onChange={(e) => setJobStatus(e.target.value)}>
                                    <option value="Any">Any</option>
                                    <option value="Not Started">Not Started</option>
                                    <option value="In Progress">In Progress</option>
                                    <option value="Cancelled">Cancelled</option>
                                    <option value="Completed">Completed</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="cp-split">
                                <label className="fi-label">Job Type</label>
                                <select className="common-select" value={jobType} onChange={(e) => setJobType(e.target.value)}>
                                    <option value="Any">Any</option>
                                    <option value="Paving">Paving</option>
                                    <option value="Gravel Supply">Gravel Supply</option>
                                    <option value="Dirt Hauling">Dirt Hauling</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="cp-split">
                                <label className="fi-label">Posted By - Construction Company</label>
                                <select className="common-select" value={postedBy} onChange={(e) => setPostedBy(e.target.value)}>
                                    <option value="Any">Any</option>
                                    {constructionCompanies.map((company) => (
                                        <option key={company.id} value={company.id}>
                                            {company.company_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="cp-split">
                                <label className="fi-label">Done By - Truck Company</label>
                                <select className="common-select" value={doneBy} onChange={(e) => setDoneBy(e.target.value)}>
                                    <option value="Any">Any</option>
                                    {truckCompanies.map((company) => (
                                        <option key={company.id} value={company.id}>
                                            {company.company_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <button className="cp-button generate-button" type="button" onClick={handleGenerate} disabled={loading}>
                        {loading ? <Loader /> : 'Generate Report'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default JobSummaryTab;